
















import Vue from 'vue'
import { Icon, Marker } from 'leaflet'
import { LIcon, LMarker } from 'vue2-leaflet'
import PlaceInformationBox from './PlaceInformationBox.vue'
import MapMarkerIcon from './MapMarkerIcon.vue'
import { QueryParameters } from '@/router'
import { postPlaceStatistic } from '@/placeStatistic'

// The following properties are set this way to avoid "net::ERR_INVALID_URL" errors in Chromium-like browsers and redundant files import as a default marker is not used anyway.
Icon.Default.prototype.options.imagePath = '.'
Icon.Default.prototype.options.iconUrl = ''
Icon.Default.prototype.options.shadowUrl = ''

export default Vue.extend({
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  components: {
    LIcon,
    LMarker,
    MapMarkerIcon,
    PlaceInformationBox
  },
  data () {
    return {
      QueryParameters
    }
  },
  computed: {
    marker () : Marker {
      return (this.$refs.marker as LMarker).mapObject
    },
    popupShouldBeOpen () : boolean {
      return this.$route.query[QueryParameters.SelectedPlaceIdentifier] == this.place['id']
    },
    markerZIndexOffset () : number {
      let offset = (this.place['transmission_type'] || 0) * 10
      if (this.$store.state.isSchedule && this.place['has_schedule_event']) {
        offset += 200
      }
      if (this.$store.state.likedPlaces.includes(this.place.id)) {
        offset += 1000
      }
      if (this.place.listing_confirmed) {
        offset += 500
      }
      return offset
    }
  },
  mounted () {
    this.$nextTick().then(this.openOrClosePopupDependingOnQueryParameter)
  },
  watch: {
    popupShouldBeOpen () {
      this.openOrClosePopupDependingOnQueryParameter()
    }
  },
  methods: {
    getMarkerClass(place: any){
      if(this.$store.state.isSchedule){
        return place.has_schedule_event ? 'primary' : 'neutral'
      }
      if(this.$store.state.isLunchMap){
        if(place.placelunchpost_set.length > 0){
          return 'primary';
        }
        else {
          return 'neutral';
        }
      }
      if(place?.transmission_type && place?.transmission_type > 4){
        return 'very-positive';
      }
      if(place?.transmission_type && place?.transmission_type > 1 && place?.transmission_type <= 4){
        return 'positive';
      }
      if((this.$store.state.selectedEvent && !place['transmission_type'])){
        return 'neutral';
      }
      return 'primary';
    },
    openOrClosePopupDependingOnQueryParameter () {
      if(this.popupShouldBeOpen){
        this.marker.openPopup()
        var lastOpened : number = parseInt(localStorage.getItem('LAST_OPENED_' + this.place.id) || '');
        var now : number = Date.now();
        if(!lastOpened || lastOpened < (now - 3 * 60 * 1000)){
          postPlaceStatistic(this.$store, {
            place: this.place.id,
            type: 'click',
            event: this.$store.state.selectedEvent && this.$store.state.selectedEvent.id || null,
            transmission_type: this.place.transmission_type || 0
          }).then(response => response.json()).catch(() => {})
        }
        localStorage.setItem('LAST_OPENED_' + this.place.id, now.toString());
      } else {
        this.marker.closePopup()
      }
    }
  }
})
